import React from 'react';

import PropTypes from 'prop-types';

import { PromoText } from 'components/no-auth/common/promo-text/PromoText';

import styles from './Date.module.css';

export const Date = (props) => {
    return (
        <>
            {props.date && (
                <div className={styles.dateContainer}>
                    <PromoText color={'gray40'} variant={props.textVariant}>
                        {props.date}
                    </PromoText>
                </div>
            )}
        </>
    );
};

Date.propTypes = {
    textVariant: PropTypes.oneOf(['span', 'subheader']),
    date: PropTypes.string,
};
